// extracted by mini-css-extract-plugin
module.exports = {"head":"EditEmployeePay__head--1VyPz","hide":"EditEmployeePay__hide--Gr-7c"};